import { Component, OnInit, Directive, Input, Output, EventEmitter, ViewChildren, QueryList } from '@angular/core';
import { PtrService } from '../ptr-service';
import { ActivatedRoute, Router } from '@angular/router';
import { encryptionService } from 'src/app/common-service/cedService';
import { ServerURLService } from 'src/app/common-service/serverURL.service';
import { EncrDecrService } from 'src/app/common-service/EncrDecrService';
import { UsrmgtService } from 'src/app/usermgt/services/usrmgt.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { SignupService } from 'src/app/common-service/signup.service';
import { HelperService } from 'src/app/common-service/helper.service';

export type SortColumn = keyof any | '';
export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': '', '': 'asc' };

export interface SortEvent {
  column: SortColumn;
  direction: SortDirection;
}

@Directive({
  selector: 'th[sortable]',
  host: {
    '[class.asc]': 'direction === "asc"',
    '[class.desc]': 'direction === "desc"',
    '(click)': 'rotate()'
  }
})
export class NgbdSortableHeader {
  @Input() sortable: SortColumn = '';
  @Input() direction: SortDirection = '';
  @Output() sort = new EventEmitter<SortEvent>();

  rotate() {
    this.direction = rotate[this.direction];
    this.sort.emit({ column: this.sortable, direction: this.direction });
  }
}


@Component({
  selector: 'app-college-institution-dashboard',
  templateUrl: './college-institution-dashboard.component.html',
  styleUrls: ['./college-institution-dashboard.component.css']
})
export class CollegeInstitutionDashboardComponent implements OnInit {
  roleName: any;
  ptrDashboardSearchCriteria = {
    rowId: 10,
    pagenumber: 1,
    pageId: 0,
    sortBy: '',
    registrationId: '',
    applicationId: '',
    name: '',
    venueProgram: '',
    purposeConducting: '',
    startDate: '',
    endDate: '',
    status: '',
    roleName: '',
    subject: '',
  }
  allPTRList: any = [];
  public totalPageCount: any;
  pageCount: any;
  registrationId: any;
  maxDate: string;
  today: Date = new Date();
  today1 = moment().format('YYYY-MM-DD');


  constructor(public router: Router, public signin: PtrService,
    public serverURL: ServerURLService, public usrMgtService: UsrmgtService,
    public ced: encryptionService, public EncrDecr: EncrDecrService,
    public spinner: NgxSpinnerService, public signinService: SignupService, public tostar: ToastrService, public route: ActivatedRoute, public helper: HelperService) { }

  ngOnInit() {
    this.roleName = sessionStorage.getItem('selectedRole-usec');
    if (this.roleName === 'PTR' || this.roleName === 'College Principal') {
      this.search();
    } else {
      this.signinService.deleteOauthToken();
    }

    this.route.params.subscribe(params => {
      if (params.paymentCode === 'E000') {
        this.tostar.success('Last Transaction is Successful', 'Success', { timeOut: 3000 });
      } else if (params.paymentCode != '0') {
        this.tostar.error("Last Transaction is Failed", 'Error', { timeOut: 2000 });
      }
    });
  }



  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  onSort({ column, direction }: SortEvent) {
    if (direction == "")
      this.ptrDashboardSearchCriteria.sortBy = "";
    else
      this.ptrDashboardSearchCriteria.sortBy = column.toString() + " " + direction;
    this.ptrDashboardSearchCriteria.pagenumber = 1;

    this.search();
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

  }


  encryption(id: any) {
    var encrypted = this.EncrDecr.set(this.serverURL.secretKey, id);
    this.router.navigate(['/main/internal/ptr/editPTR/', encrypted]);
  }

  encryptionView(id: any) {
    var encrypted = this.EncrDecr.set(this.serverURL.secretKey, id);
    this.router.navigate(['/main/internal/ptr/viewPTR/', encrypted]);
  }

  searchClick() {
    this.ptrDashboardSearchCriteria.pagenumber = 1;
    this.search();
  }

  reset() {
    this.ptrDashboardSearchCriteria = {
      rowId: 10,
      pagenumber: 1,
      pageId: 0,
      sortBy: '',
      registrationId: '',
      applicationId: '',
      name: '',
      venueProgram: '',
      purposeConducting: '',
      startDate: '',
      endDate: '',
      status: '',
      roleName: '',
      subject: '',
    }
    this.search();
  }

  search() {
    this.ptrDashboardSearchCriteria.roleName = this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString();
    this.ptrDashboardSearchCriteria.pageId = (this.ptrDashboardSearchCriteria.pagenumber - 1) * this.ptrDashboardSearchCriteria.rowId;
    if (sessionStorage.getItem("back") == "back") {
      sessionStorage.setItem("back", "");
      this.ptrDashboardSearchCriteria = JSON.parse(sessionStorage.getItem("ptrDashboardSearchCriteria"));
    } else {
      sessionStorage.setItem("ptrDashboardSearchCriteria", JSON.stringify(this.ptrDashboardSearchCriteria));
    }
    this.spinner.show();
    this.signin.getAllInstitutionAndCollegePtrApplicationlist(this.ptrDashboardSearchCriteria).subscribe((result: any) => {
      this.spinner.hide();
      if (result.length === 0) {
        this.allPTRList = [];
        this.pageCount = 0;
        this.totalPageCount = 0;
      } else {
        this.allPTRList = result;
        this.pageCount = Math.ceil(this.allPTRList[0].count / this.ptrDashboardSearchCriteria.rowId);
        this.totalPageCount = this.allPTRList[0].count;
      }

    }, error => {
      this.spinner.hide();
      console.log(error);
      this.helper.errorMessage(error);
    });

  }

  selecetdDate(data: any) {
    this.maxDate = moment(data).add(0, 'days').format('YYYY-MM-DD');
    this.ptrDashboardSearchCriteria.endDate = '';
  }

  first() {
    this.ptrDashboardSearchCriteria.pagenumber = 1;
    this.ptrDashboardSearchCriteria.pageId = 0;
    this.search();
  }

  prev() {
    if (this.ptrDashboardSearchCriteria.pagenumber > 1) {
      this.ptrDashboardSearchCriteria.pagenumber--;
      this.search();
    }
  }

  next() {
    if (this.ptrDashboardSearchCriteria.pagenumber < this.pageCount) {
      this.ptrDashboardSearchCriteria.pagenumber++;
      this.search();
    }
  }

  changePage(pagenumber) {
    if (pagenumber != null) {
      if (parseInt(pagenumber) <= this.pageCount) {
        this.ptrDashboardSearchCriteria.pagenumber = pagenumber;
        this.search();
      }
      else
        this.ptrDashboardSearchCriteria.pagenumber == 1;
      this.search();
    }
  }

  last() {
    if (this.ptrDashboardSearchCriteria.pagenumber != this.pageCount) {
      this.ptrDashboardSearchCriteria.pagenumber = this.pageCount;
      this.search();
    }
  }
}
